export default __webpack_public_path__ + "static/media/kitchen3.e94932de.jpg";